import * as types from './mutation-types'

export default {
  [types.FILL_PROTOCOLS](state, payload = { protocols }) {
    state.protocols = payload.protocols
    state.protocolsLoaded = true
  },   
}
